export const TRANSLATION_MANAGEMENT_FLAGS = {
    aiTranslationFlag: {
        id: 'aiTranslation',
        value: false,
        description: 'Enables instant translation using generative AI',
        owner: 'Translation Team',
        name: 'Generate Translation (AI)',
        extra: { section: 'Translation' },
    },
    targetedAiStudyTranslation: {
        id: 'targetedAiStudyTranslation',
        value: false,
        description: 'Enables targeted AI study translation',
        owner: 'Translation Team',
        name: 'Targeted AI study translation',
        extra: { section: 'Translation' },
    },
};
